module.exports = __webpack_public_path__ + "static/media/agenda_darkbleu.c00a7ae3.svg";